// read-workspace-settings-env-override.ts
//
// Generic reader: đọc override `env.<key>` từ <workspace>/.claude/settings.json —
// tầng (b) trong precedence resolve endpoint (auth-device; get-pack có reader
// riêng cũ `read-workspace-get-pack-endpoint-override.ts`, GIỮ NGUYÊN không
// refactor code đang chạy). Workspace-level ONLY: KHÔNG đọc global ~/.claude.
//
// SYNC có chủ đích: caller (resolveAuthDeviceEndpoint) là sync → readFileSync.
//
// Fail-SOFT: workspace không tìm thấy / file không tồn tại / JSON lỗi / thiếu key
// / value sai kiểu → trả undefined (caller fallback tầng sau). Giá trị trả về
// vẫn phải qua gate HTTPS+whitelist ở caller — đây KHÔNG phải nguồn tin cậy.
import { readFileSync } from "node:fs";
import { resolveAvatarWorkspaceRootFromCwd } from "./resolve-avatar-workspace-root-from-cwd.js";
import { getClaudeSettingsPath } from "./write-claude-settings-json-per-project.js";

export function readWorkspaceSettingsEnvOverride(key: string): string | undefined {
  const workspace = resolveAvatarWorkspaceRootFromCwd(process.cwd());
  if (!workspace) return undefined;
  try {
    const raw = readFileSync(getClaudeSettingsPath(workspace), "utf8");
    const settings = JSON.parse(raw) as { env?: Record<string, unknown> };
    const value = settings.env?.[key];
    return typeof value === "string" ? value : undefined;
  } catch {
    return undefined; // file thiếu / JSON lỗi → bỏ qua tầng này, KHÔNG throw
  }
}
